var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000370502 4.14354V3.31483H3.21666V2.07178L5.00391 3.72919L3.21666 5.3866V4.14354H-0.000370502Z",
    fill: "#003777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35908 0H5.57612C5.97038 0 6.29102 0.371674 6.29102 0.828705V2.48611H5.57612V0.828705H2.35908V6.62964H5.57612V4.97223H6.29102V6.62964C6.29102 7.08667 5.97038 7.45834 5.57612 7.45834H2.35908C1.96482 7.45834 1.64419 7.08667 1.64419 6.62964V0.828705C1.64419 0.371674 1.96482 0 2.35908 0Z",
    fill: "#003777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon_2.be22fcad1953fbf86ca1066afbf6b571.svg";
export { ForwardRef as ReactComponent };